import React, { useEffect, useState } from "react";
import Button from "../../extras/Button";
import { ExInput } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { permissionError } from "../../../util/Alert";
import { addHoliday } from "../../../redux/slice/holidaySlice";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { getAllSalons } from "../../../redux/slice/salonSlice";
import { Box, Modal } from "@mui/material";
const BannerDialog = () => {
  const dispatch = useDispatch();
  const hasPermission = useSelector((state) => state.auth.admin.flag);
  const { salon } = useSelector((state) => state.salon);

  const [reason, setReason] = useState("");
  const [salonId, setSalonId] = useState("");

  const today = new Date();
  const [date, setDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [error, setError] = useState({
    salonId: "",
    date: "",
    endDate: "",
    reason: "",
  });

  useEffect(() => {
    let payload = {
      start: "ALL",
      limit: "ALL",
      search: "ALL",
    };
    dispatch(getAllSalons(payload));
  }, [dispatch]);

  const handleSubmit = () => {
    if (!hasPermission) return permissionError();
    if (!date || !salonId || !endDate || !reason) {
      let error = {};
      if (!date) error.date = "Date is required";
      if (!salonId) error.salonId = "Salon is required";
      if (!endDate) error.endDate = "End date is required";
      if (!reason) error.reason = "Reason is required";
      return setError({ ...error });
    } else {
      const hDate = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
      const hEndDate = moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD");

      let data = {
        startDate: hDate,
        endDate: hEndDate,
        reason: reason && reason,
      };
      let payload = { salonId, data };

      dispatch(addHoliday(payload)).unwrap();
    }
    dispatch(closeDialog());
  };

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
  };
  const handleEndDateChange = (selectedDate) => {
    setEndDate(selectedDate);
  };

  return (
    <Modal
      open={true}
      onClose={closeDialog}
    >
      <Box className="model-style">
      <div className="model-header">
          <p className="m-0">Add Holiday</p>
        </div>

        <div className="model-body">
          <div className="row align-items-start formBody">
            <div className="col-12">
              <div className="inputData text  flex-row justify-content-start text-start">
                <label for="fname" className="false text-capitalize">
                  Select Salon
                </label>
                <select
                  name="bookingType"
                  
                  className="form-select"
                  id="bookingType"
                  value={salonId}
                  onChange={(e) => {
                    const selectedSalonId = e.target.value;
                    setSalonId(selectedSalonId);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        salonId: `Salon is required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        salonId: "",
                      });
                    }
                  }}
                >
                  <option selected disabled>
                    Select Salon
                  </option>
                  {salon.map((data) => (
                    <option key={data?._id} value={data?._id}>
                      {data?.name}
                    </option>
                  ))}
                </select>
                {error.salonId && (
                  <p className="errorMessage text-capitalize">
                    {error.salonId && error.salonId}
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="">
                <label className="me-4">Choose Start Date</label>
                <ReactDatePicker
                  selected={date}
                  onChange={handleDateChange}
                  dateFormat="yyyy-MM-dd"
                  minDate={new Date()}
                />
                {error.date && (
                  <p className="errorMessage text-capitalize">
                    {error.date && error.date}
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="">
                <label className="me-4">Choose End Date</label>
                <ReactDatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  dateFormat="yyyy-MM-dd"
                  minDate={date}
                />
                {error.endDate && (
                  <p className="errorMessage text-capitalize">
                    {error.endDate && error.endDate}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12">
              <ExInput
                label={`Reason`}
                id={`reason`}
                placeholder="Enter reason"
                type={`text`}
                errorMessage={error.reason && error.reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      reason: `Reason is required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      reason: "",
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="model-footer">

          <div className="m-3 d-flex justify-content-end gap-2">
           
              <Button
                className={`close-model-btn`}
                text={`Cancel`}
                type={`button`}
                onClick={() => dispatch(closeDialog())}
              />
              <Button
                type={`submit`}
                text={`Submit`}
                onClick={(e) => handleSubmit(e)}
              />
            </div>
          
        </div>
      </Box>

    </Modal>

  );
};

export default BannerDialog;
